import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { Container, Row, Col, Label, FormGroup, Input } from "reactstrap"
import MailchimpSubscribe from "react-mailchimp-subscribe"
import styled, { css } from "styled-components"
import { media } from "utils/Media"
import Button from "components/shared/Button"
import Text from "components/shared/Text"
import { useState } from "react"

const ContainerStyled = styled(Container)`
	background:${props => props.theme.colors.tertiary};
	color: ${props => props.theme.colors.grey1};   
	padding-top: 1.5rem;
	padding-bottom: 1.5rem;

	@media ${media.md} {
		padding-top: 3rem;
		padding-bottom: 3rem;
	}

	label {
		font-size: ${props => props.theme.font.size.sm};
		margin: 0;
	}
	input[type='checkbox'] {
		width: 20px;
		height: 20px;
		border-radius: 0!important;
		float: none!important;
	}

	a {
		color: ${props => props.theme.colors.yellow};
		
		&:hover {
			text-decoration: underline;
		}
	}
`

const FormWrap = styled.form`
	padding-top: 1rem;	
	width: 100%;
`

const StyledInput = styled.input`
	color: ${props => props.theme.colors.grey1};
	background-color: ${props => props.theme.colors.white};
	padding: .15rem 1rem;
	width: 100%;
	border: 1px solid ${props => props.theme.colors.grey2};
	height: 50px;

	&::placeholder {
		color: ${props => props.theme.colors.grey3};
		font-weight: ${props => props.theme.font.weight.bold};
	}
	@media ${media.lg} {
		height: 53px;
	}
`

const StyledSelect = styled.select`
	color: ${props => props.theme.colors.grey1};
	background-color: ${props => props.theme.colors.white};
	padding: .15rem 1rem;
	width: 100%;
	border: 1px solid ${props => props.theme.colors.grey2};
	height: 50px;
	.placeholder {
		color: ${props => props.theme.colors.grey3};
		font-weight: ${props => props.theme.font.weight.bold};
	}
	@media ${media.lg} {
		height: 53px;
	}
`

const SubmitButton = styled(Button)`
	/* margin-top: 2.5rem; */
	padding-left: 2.5rem;
	padding-right: 2.5rem;
	margin: .5rem auto 0 auto;
	@media ${media.md} {
		margin: 0;
	}
`

const ErrorMessage = styled.div`
	color: ${props => props.theme.colors.red}; 
	font-size: ${props => props.theme.font.size.sm}; 
	text-align: left;
	padding-bottom: 1rem;

	a {
		color: ${props => props.theme.colors.white};
	}

	${props => props.left && css`
		text-align: left;
	`}
`
const ErrorStyles = styled.div`
	width: 100%;
	.form-check {
		padding-left: 0;
		.form-check-label {
			display: block;
			color: ${props => props.theme.colors.white};
		}
	}

	.check-wrap {
		display: flex;

		.check-col {

			&:first-child { 
				width: 40px;
				padding-right: 1rem;
			}

			input[type="checkbox"] {
				margin: 0;
			}
		}
	}
`

const TextStyled = styled(Text)`
	font-size: 1.25rem;

	@media ${media.md} {
		font-size: 1.65rem;
	}
`

const NewsletterForm = (props) => {
	const [values, setValues] = useState({
		FNAME: "",
		LNAME: "",
		EMAIL: "",
		COUNTRY: "",
		EMIRATE: "",
	})
	const [termsChecked, setTermsChecked] = useState(false)
	const [termsError, setTermsError] = useState(false)

    // componentDidUpdate(previousProps) {
    //     if (previousProps.status !== this.props.status) {
    //         if (this.props.status === "success") {
    //             this.setState({
    //                 FNAME: "",
    //                 LNAME: "",
    //                 EMAIL: "",
    //                 COUNTRY: "",
    //                 termsChecked: false,
    //                 termsError: false
    //             })
    //         }
    //     }
    // }

	const formatMessage = (message) => {
		if (message.includes("0 - Please enter a value")) {
			return "Please enter your email address."
		}
		if (message.includes("1 - Please enter a value")) {
			return "Please enter your first name."
		}
		if (message.includes("2 - Please enter a value")) {
			return "Please enter your last name."
		}
		if (message.includes("4 - Please enter a value")) {
			return "Please select your country."
		}

		if (message.includes("An email address must contain")) {
			return "Please enter a valid email address."
		}

		if (message.includes("The domain portion of the email address is invalid")) {
			return "Please enter a valid email address."
		}

		if (message.includes("This email cannot be added to this list")) {
			return "This email address is already registered. Please enter a different email address."
		}

		return message
	}

	const handleChange = (e) => {
		const target = e.target;
		const name = target.name;
		const value = target.value;

		setValues(values => ({
			...values,
			[name] : value,
		}))
	}

  const handleCheckboxChange = (e) => {
		setTermsChecked(e.target.checked)
	}        

  const handleSubmit = (e) => {
		e.preventDefault();
		if (termsChecked) {
			setTermsError(false)
			props.onValidated({
				FNAME: values.FNAME,
				LNAME: values.LNAME,
				EMAIL: values.EMAIL,
				COUNTRY: values.COUNTRY,
				EMIRATE: values.EMIRATE,
			})
		} else {
			setTermsError(true)
		}
	}

	return (
		<FormWrap onSubmit={handleSubmit}>
			<Row className="justify-content-center">
				<Col xs={12} lg={9}>
					<Row className="justify-content-center">
						<Col xs={12} md={6} className="pb-4">
							<Label className="d-none" for="FNAME">FIRST NAME</Label>
							<StyledInput
								type="text"
								name="FNAME"
								id="FNAME"
								placeholder="Your first name"
								value={values.FNAME}
								onChange={e => {
									handleChange(e)
								}}
							/>
						</Col>
						<Col xs={12} md={6} className="pb-4">
							<Label className="d-none" for="LNAME">LAST NAME</Label>
							<StyledInput
								type="text"
								name="LNAME"
								id="LNAME"
								placeholder="Your last name"
								value={values.LNAME}
								onChange={e => {
									handleChange(e)
								}}
							/>
						</Col>
						<Col xs={12} md={6} className="pb-4">
							<Label className="d-none" for="EMAIL">EMAIL*</Label>
							<StyledInput
								type="email"
								name="EMAIL"
								id="EMAIL"
								placeholder="Your email address"
								value={values.EMAIL}
								onChange={e => {
									handleChange(e)
								}}
							/>
						</Col>
						<Col xs={12} md={6} className="pb-4">
							<Label className="d-none" for="EMAIL">Country*</Label>

							<div className="pb-4">
								<StyledSelect
									id="country"
									name="COUNTRY"
									value={values.COUNTRY}
									onChange={handleChange}
								>
									<option defaultValue="null" value="null" className="placeholder">
											Select Country
									</option>
									<option value="United Arab Emirates">United Arab Emirates</option>
									<option value="Afghanistan">Afghanistan</option>
									<option value="Albania">Albania</option>
									<option value="Algeria">Algeria</option>
									<option value="Andorra">Andorra</option>
									<option value="Angola">Angola</option>
									<option value="Antigua and Barbuda">Antigua and Barbuda</option>
									<option value="Argentina">Argentina</option>
									<option value="Armenia">Armenia</option>
									<option value="Aruba">Aruba</option>
									<option value="Australia">Australia</option>
									<option value="Austria">Austria</option>
									<option value="Azerbaijan">Azerbaijan</option>
									<option value="Bahamas, The">Bahamas, The</option>
									<option value="Bahrain">Bahrain</option>
									<option value="Bangladesh">Bangladesh</option>
									<option value="Barbados">Barbados</option>
									<option value="Belarus">Belarus</option>
									<option value="Belgium">Belgium</option>
									<option value="Belize">Belize</option>
									<option value="Benin">Benin</option>
									<option value="Bermuda">Bermuda</option>
									<option value="Bhutan">Bhutan</option>
									<option value="Bolivia">Bolivia</option>
									<option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
									<option value="Botswana">Botswana</option>
									<option value="Brazil">Brazil</option>
									<option value="Brunei">Brunei</option>
									<option value="Bulgaria">Bulgaria</option>
									<option value="Burkina Faso">Burkina Faso</option>
									<option value="Burundi">Burundi</option>
									<option value="Cambodia">Cambodia</option>
									<option value="Cameroon">Cameroon</option>
									<option value="Canada">Canada</option>
									<option value="Cape Verde">Cape Verde</option>
									<option value="Central African Republic">Central African Republic</option>
									<option value="Chad">Chad</option>
									<option value="Chile">Chile</option>
									<option value="China">China</option>
									<option value="Colombia">Colombia</option>
									<option value="Comoros">Comoros</option>
									<option value="Congo, Republic of the">Congo, Republic of the</option>
									<option value="Congo, Democratic Republic of the">Congo, Democratic Republic of the</option>
									<option value="Costa Rica">Costa Rica</option>
									<option value="Cote d'Ivoire">Cote d'Ivoire</option>
									<option value="Croatia">Croatia</option>
									<option value="Cuba">Cuba</option>
									<option value="Cyprus">Cyprus</option>
									<option value="Czech Republic">Czech Republic</option>
									<option value="Denmark">Denmark</option>
									<option value="Djibouti">Djibouti</option>
									<option value="Dominica">Dominica</option>
									<option value="Dominican Republic">Dominican Republic</option>
									<option value="Ecuador">Ecuador</option>
									<option value="Egypt">Egypt</option>
									<option value="El Salvador">El Salvador</option>
									<option value="Equatorial Guinea">Equatorial Guinea</option>
									<option value="Eritrea">Eritrea</option>
									<option value="Estonia">Estonia</option>
									<option value="Ethiopia">Ethiopia</option>
									<option value="Fiji">Fiji</option>
									<option value="Finland">Finland</option>
									<option value="France">France</option>
									<option value="Gabon">Gabon</option>
									<option value="Gambia, The">Gambia, The</option>
									<option value="Georgia">Georgia</option>
									<option value="Germany">Germany</option>
									<option value="Ghana">Ghana</option>
									<option value="Greece">Greece</option>
									<option value="Grenada">Grenada</option>
									<option value="Guatemala">Guatemala</option>
									<option value="Guinea">Guinea</option>
									<option value="Guinea-Bissau">Guinea-Bissau</option>
									<option value="Guyana">Guyana</option>
									<option value="Haiti">Haiti</option>
									<option value="Honduras">Honduras</option>
									<option value="Hungary">Hungary</option>
									<option value="Iceland">Iceland</option>
									<option value="India">India</option>
									<option value="Indonesia">Indonesia</option>
									<option value="Iraq">Iraq</option>
									<option value="Ireland">Ireland</option>
									<option value="Islamic Republic of Iran">Islamic Republic of Iran</option>
									<option value="Israel">Israel</option>
									<option value="Italy">Italy</option>
									<option value="Jamaica">Jamaica</option>
									<option value="Japan">Japan</option>
									<option value="Jordan">Jordan</option>
									<option value="Kazakhstan">Kazakhstan</option>
									<option value="Kenya">Kenya</option>
									<option value="Kiribati">Kiribati</option>
									<option value="Korea, The Democratic People's Republic of">Korea, The Democratic People's Republic of</option>
									<option value="Korea, The Republic of">Korea, The Republic of</option>
									<option value="Kosovo">Kosovo</option>
									<option value="Kuwait">Kuwait</option>
									<option value="Kyrgyzstan">Kyrgyzstan</option>
									<option value="Lao People's Democratic Republic">Lao People's Democratic Republic</option>
									<option value="Latvia">Latvia</option>
									<option value="Lebanon">Lebanon</option>
									<option value="Lesotho">Lesotho</option>
									<option value="Liberia">Liberia</option>
									<option value="Liechtenstein">Liechtenstein</option>
									<option value="Lithuania">Lithuania</option>
									<option value="Luxembourg">Luxembourg</option>
									<option value="Macedonia">Macedonia</option>
									<option value="Madagascar">Madagascar</option>
									<option value="Malawi">Malawi</option>
									<option value="Malaysia">Malaysia</option>
									<option value="Maldives">Maldives</option>
									<option value="Mali">Mali</option>
									<option value="Malta">Malta</option>
									<option value="Marshall Islands">Marshall Islands</option>
									<option value="Mauritania">Mauritania</option>
									<option value="Mauritius">Mauritius</option>
									<option value="Mexico">Mexico</option>
									<option value="Micronesia, Federated States of">Micronesia, Federated States of</option>
									<option value="Monaco">Monaco</option>
									<option value="Mongolia">Mongolia</option>
									<option value="Montenegro">Montenegro</option>
									<option value="Morocco">Morocco</option>
									<option value="Mozambique">Mozambique</option>
									<option value="Myanmar (Burma)">Myanmar (Burma)</option>
									<option value="Namibia">Namibia</option>
									<option value="Nauru">Nauru</option>
									<option value="Nepal">Nepal</option>
									<option value="Netherlands">Netherlands</option>
									<option value="New Zealand">New Zealand</option>
									<option value="Nicaragua">Nicaragua</option>
									<option value="Niger">Niger</option>
									<option value="Nigeria">Nigeria</option>
									<option value="Norway">Norway</option>
									<option value="Oman">Oman</option>
									<option value="Pakistan">Pakistan</option>
									<option value="Palau">Palau</option>
									<option value="Palestine">Palestine</option>
									<option value="Panama">Panama</option>
									<option value="Papua New Guinea">Papua New Guinea</option>
									<option value="Paraguay">Paraguay</option>
									<option value="Peru">Peru</option>
									<option value="Philippines">Philippines</option>
									<option value="Poland">Poland</option>
									<option value="Portugal">Portugal</option>
									<option value="Qatar">Qatar</option>
									<option value="Republic of Moldova">Republic of Moldova</option>
									<option value="Romania">Romania</option>
									<option value="Russia">Russia</option>
									<option value="Rwanda">Rwanda</option>
									<option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
									<option value="Saint Lucia">Saint Lucia</option>
									<option value="Saint Vincent and the Grenadines">Saint Vincent and the Grenadines</option>
									<option value="Samoa">Samoa</option>
									<option value="San Marino">San Marino</option>
									<option value="Sao Tome and Principe">Sao Tome and Principe</option>
									<option value="Saudi Arabia">Saudi Arabia</option>
									<option value="Senegal">Senegal</option>
									<option value="Serbia">Serbia</option>
									<option value="Seychelles">Seychelles</option>
									<option value="Sierra Leone">Sierra Leone</option>
									<option value="Singapore">Singapore</option>
									<option value="Slovakia">Slovakia</option>
									<option value="Slovenia">Slovenia</option>
									<option value="Solomon Islands">Solomon Islands</option>
									<option value="Somalia">Somalia</option>
									<option value="South Africa">South Africa</option>
									<option value="South Sudan">South Sudan</option>
									<option value="Spain">Spain</option>
									<option value="Sri Lanka">Sri Lanka</option>
									<option value="Sudan">Sudan</option>
									<option value="Suriname">Suriname</option>
									<option value="Swaziland">Swaziland</option>
									<option value="Sweden">Sweden</option>
									<option value="Switzerland">Switzerland</option>
									<option value="Syrian Arab Republic">Syrian Arab Republic</option>
									<option value="Taiwan">Taiwan</option>
									<option value="Tajikistan">Tajikistan</option>
									<option value="Thailand">Thailand</option>
									<option value="Timor-Leste">Timor-Leste</option>
									<option value="Togo">Togo</option>
									<option value="Tonga">Tonga</option>
									<option value="Trinidad and Tobago">Trinidad and Tobago</option>
									<option value="Tunisia">Tunisia</option>
									<option value="Turkey">Turkey</option>
									<option value="Turkmenistan">Turkmenistan</option>
									<option value="Tuvalu">Tuvalu</option>
									<option value="Uganda">Uganda</option>
									<option value="Ukraine">Ukraine</option>
									<option value="United Kingdom">United Kingdom</option>
									<option value="United Republic of Tanzania">United Republic of Tanzania</option>
									<option value="United States of America">United States of America</option>
									<option value="Uruguay">Uruguay</option>
									<option value="Uzbekistan">Uzbekistan</option>
									<option value="Vanuatu">Vanuatu</option>
									<option value="Vatican City (Holy See)">Vatican City (Holy See)</option>
									<option value="Vietnam">Vietnam</option>
									<option value="Yemen">Yemen</option>
									<option value="Zambia">Zambia</option>
									<option value="Zimbabwe">Zimbabwe</option>
								</StyledSelect>
							</div>

							{values.COUNTRY === "United Arab Emirates" &&
								<div>
									<label htmlFor="EMIRATE" className="sr-only">What is your emirate?</label>
									<div>                        
									<StyledSelect
										id="emirate"
										name="EMIRATE"
										value={values.EMIRATE}
										className="last"
										onChange={handleChange}
									>
										<option defaultValue="" value="">
											What is your emirate?
										</option>
										<option value="Abu Dhabi">Abu Dhabi</option>
										<option value="Ajman">Ajman</option>
										<option value="Dubai">Dubai</option>
										<option value="Fujairah">Fujairah</option>
										<option value="Ras Al Khaimah">Ras Al Khaimah</option>
										<option value="Sharjah">Sharjah</option>
										<option value="Umm Al Quwain">Umm Al Quwain</option>
									</StyledSelect>
									</div>
								</div>
							}
						</Col>
						{props.status === "error" &&
							<Col xs={12}>   
								<ErrorMessage dangerouslySetInnerHTML={{ __html: formatMessage(props.message) }} />
							</Col>
						}
					</Row>
				</Col>
				<Col xs={12} lg={9} className="pb-4">
					<Row>
						<Col>
							<ErrorStyles>
								<FormGroup check>
									<Label check>
										<div className="check-wrap">
											<div className="check-col">
												<Input type="checkbox" id="terms" onChange={handleCheckboxChange} checked={termsChecked} />{' '}
											</div>
											<div className="check-col">
												<div dangerouslySetInnerHTML={{ __html: props.termsText }} />
												{termsError &&
													<ErrorMessage left>Please accept our terms.</ErrorMessage>
												}
											</div>
										</div>
									</Label>
								</FormGroup>
							</ErrorStyles>
						</Col>
						<Col xs={12} md="auto" className="d-flex align-items-center justify-content-center pt-4 pt-md-0">
							<SubmitButton as="button" color="tertiary" disabled={values.EMAIL === ""}>
								{props.buttonText}
							</SubmitButton>
						</Col>
					</Row>
				</Col>
				{props.status === "success" && (
					<Col xs={12} md={{ order: 2 }} className="pt-4">
						<h4 className="mt-4 m-md-0 text-white text-center">
							<div dangerouslySetInnerHTML={{ __html: props.successText }} />
						</h4>
					</Col>
				)} 
			</Row>
		</FormWrap>
	)
}

const NewsletterSignup = (props) => {
	const url = "https://img.us12.list-manage.com/subscribe/post?u=0785efbb63e5c3e387c7d7141&id=aca3ce2b62&f_id=009ab5e0f0"
	

	const data = useStaticQuery(graphql`
		query {
			allWp {
				edges {
					node {
						options {
							acfOptions {
								blockNewsletterSignup {
									text
									termsText
									buttonText
									successText
								}
							}
						}
					}
				}
			}
		}
	`)

	const { blockNewsletterSignup } = data.allWp.edges[0]?.node?.options?.acfOptions
	
	if (blockNewsletterSignup) {
		return (
			<ContainerStyled fluid id="newsletter-signup">
				<Container>
					<TextStyled as="div" $center $secondary dangerouslySetInnerHTML={{ __html: blockNewsletterSignup.text }} />
					<MailchimpSubscribe
						url={url}
						render={({ subscribe, status, message }) => (
							<>
								<NewsletterForm
									status={status}
									message={message}
									onValidated={formData => subscribe(formData)}
									termsText={blockNewsletterSignup.termsText}
									buttonText={blockNewsletterSignup.buttonText}
									successText={blockNewsletterSignup.successText}
								/>
							</>
						)}
					/>
				</Container>
			</ContainerStyled>
		)
	} else return ""
}

export default NewsletterSignup